// Test IDs for the Design Requests pages (M3.2 / M3.3 / M3.4).
export const DESIGN_REQUESTS = {
  // List page
  listRoot: "design-requests-list",
  newButton: "design-requests-new",
  rowPrefix: "design-requests-row-",
  emptyState: "design-requests-empty",

  // Create / edit form
  formRoot: "design-request-form",
  formTemplate: "design-request-template-select",
  formLocation: "design-request-location-select",
  formBrief: "design-request-brief-textarea",
  formContentItemPrefix: "design-request-content-",
  formSubmit: "design-request-submit",
  formCancel: "design-request-cancel",

  // Detail
  detailRoot: "design-request-detail",
  detailStatus: "design-request-status",
  generateButton: "design-request-generate",
  detailBrief: "design-request-detail-brief",
  detailSummary: "design-request-detail-summary",
  detailWarnings: "design-request-detail-warnings",
  detailPanelPrefix: "design-request-detail-panel-",
  detailElementPrefix: "design-request-detail-element-",
  // M5 — Approval
  approvalBanner: "design-request-approval-banner",
  approvalStatus: "design-request-approval-status",
  submitButton: "design-request-approval-submit",
  approveButton: "design-request-approval-approve",
  rejectButton: "design-request-approval-reject",
  withdrawButton: "design-request-approval-withdraw",
  approvalCommentInput: "design-request-approval-comment",
  approvalConfirmYes: "design-request-approval-confirm-yes",
  approvalConfirmCancel: "design-request-approval-confirm-cancel",
  approvalHistoryItemPrefix: "design-request-approval-history-",
  // M5 — Export / Fulfillment
  exportButton: "design-request-export-button",
  exportLink: "design-request-export-link",
  fulfillmentLink: "design-request-fulfillment-link",
  // Debug — admin only
  previewPromptButton: "design-request-preview-prompt",
  previewPromptModal: "design-request-preview-prompt-modal",
  previewPromptClose: "design-request-preview-prompt-close",
  previewPromptSystem: "design-request-preview-prompt-system",
  previewPromptUser: "design-request-preview-prompt-user",
  previewPromptCopySystem: "design-request-preview-prompt-copy-system",
  previewPromptCopyUser: "design-request-preview-prompt-copy-user",
};

export const APPROVALS = {
  listRoot: "approvals-list",
  emptyState: "approvals-empty",
  rowPrefix: "approvals-row-",
  rowApproveButton: "approvals-row-approve-",
  rowRejectButton: "approvals-row-reject-",
  rowOpenButton: "approvals-row-open-",
};
